import { BinIcon } from '../../../../components/icon/Icon';
import {ProfileIconWrapperStyled, ProfileIndicatorStyled} from "./styled/ProfileIconStyled";

export const ProfileIcon = ({ showArrow, showIndicator }) => (
    <ProfileIconWrapperStyled>
        <BinIcon name={'IcPerson'} style={{fontSize: '20px'}}/>
        {showIndicator && <ProfileIndicatorStyled />}
        {!!showArrow && <BinIcon name="IcChevronDown" style={{marginLeft: '4px'}} className="profile-icon-arrow"/>}
    </ProfileIconWrapperStyled>
);
